/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type loginOauth_QueryVariables = {};
export type loginOauth_QueryResponse = {
    readonly viewer: {
        readonly component: string | null;
        readonly " $fragmentRefs": FragmentRefs<"loginOauth_viewer">;
    } | null;
};
export type loginOauth_Query = {
    readonly response: loginOauth_QueryResponse;
    readonly variables: loginOauth_QueryVariables;
};



/*
query loginOauth_Query {
  viewer {
    component(name: "login_oauth")
    ...loginOauth_viewer
    id
  }
}

fragment loginOauth_viewer on Viewer {
  id
  actualPersonId
  firstName
  lastName
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "login_oauth"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"login_oauth\")"
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "loginOauth_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "loginOauth_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "loginOauth_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "actualPersonId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "loginOauth_Query",
    "operationKind": "query",
    "text": "query loginOauth_Query {\n  viewer {\n    component(name: \"login_oauth\")\n    ...loginOauth_viewer\n    id\n  }\n}\n\nfragment loginOauth_viewer on Viewer {\n  id\n  actualPersonId\n  firstName\n  lastName\n}\n"
  }
};
})();
(node as any).hash = '677c45e58e6033e6e3dc02bce84659d7';
export default node;
